import { useContext } from "react";
import { Position } from "@xyflow/react";
import { DiagramDirectionContext } from "../_diagramDirectionContext";

export function useDiagramHandlePositions() {
  const dir = useContext(DiagramDirectionContext);
  const isHorizontal = dir === "RIGHT";
  return {
    source: isHorizontal ? Position.Right : Position.Bottom,
    target: isHorizontal ? Position.Left : Position.Top,
    isHorizontal,
  };
}
